module.exports = __webpack_public_path__ + "img/pointing-himself.be4ae699.png";